import i18next from 'i18next';

i18next.addResources('es_CL', 'LastPaymentUsed', {
  change: 'Cambiar'
});

i18next.addResources('pt_pt', 'LastPaymentUsed', {
  change: 'Alterar'
});
